import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Controller, useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import React from 'react';
import {
  CreatePublicationArgs,
  useCreatePublication,
} from '@contexts/PropertyListingPublications/gql/hooks';

type StartPublicationButtonProps = {
  open: boolean;
  onClose: () => void;
  onCreated: (data: CreatePublicationArgs & { id: string }) => void;
};

export function CreatePublicationModal(props: StartPublicationButtonProps) {
  const { open, onClose } = props;

  const createPublication = useCreatePublication();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
    reset,
  } = useForm<CreatePublicationArgs>({
    defaultValues: {
      name: '',
      description: '',
    },
  });

  const onSubmit = async (data: CreatePublicationArgs) => {
    const result = await createPublication.create(data);

    props.onCreated({
      ...data,
      id: result,
    });
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Iniciar proceso de publicación</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Para continuar, por favor ingresa cómo quieres identificar esta
          publicación, este nombre solo será visible para ti.
        </DialogContentText>

        <Controller
          control={control}
          name="name"
          rules={{
            required: true,
            minLength: 5,
            maxLength: 128,
          }}
          render={({ field, fieldState }) => (
            <TextField
              margin="dense"
              id="name"
              label="Nombre de la publicación"
              type="text"
              fullWidth
              variant="outlined"
              required
              error={fieldState.error !== undefined}
              helperText={
                fieldState.error?.type === 'required'
                  ? 'Este campo es requerido'
                  : fieldState.error?.type === 'minLength'
                  ? 'El nombre debe tener al menos 5 caracteres'
                  : fieldState.error?.type === 'maxLength'
                  ? 'El nombre debe tener menos de 128 caracteres'
                  : ''
              }
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="description"
          rules={{
            required: false,
            maxLength: 256,
          }}
          render={({ field, fieldState }) => (
            <TextField
              margin="dense"
              id="description"
              label="Descripción de la publicación"
              type="text"
              fullWidth
              variant="outlined"
              multiline
              maxRows={4}
              error={fieldState.error !== undefined}
              helperText={
                fieldState.error?.type === 'maxLength'
                  ? 'La descripción debe tener menos de 256 caracteres'
                  : ''
              }
              {...field}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
        >
          Iniciar publicación
        </Button>
      </DialogActions>
    </Dialog>
  );
}
